import { SubNav } from '@/components/ui/page';

/** Tabs between the channels clients write on: all of them first, then Telegram (TG-*), email (Q17) and Instagram (Q18). */
const ChannelNav = () => (
  <SubNav
    label="Channels"
    items={[
      { to: '/conversations', label: 'All channels', end: true },
      { to: '/conversations/telegram', label: 'Telegram' },
      { to: '/conversations/email', label: 'Email', off: 'mailbox' },
      { to: '/conversations/instagram', label: 'Instagram', off: 'instagram' },
    ]}
  />
);

export default ChannelNav;
